module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "hamilton.242e06a8.svg";